import { Navigate, useLocation } from "react-router-dom";

import { createRerouteRegex } from "App/routes/pageNames";
import { LegacyPagePaths } from "App/routes/paths";
import { useLiveOpsPathing } from "Pages/liveOps/useLiveOpsPathing";

export function QueuesRerouter(): JSX.Element {
    const location = useLocation();
    const pathAfterQueues = location.pathname.replace(createRerouteRegex(LegacyPagePaths.queues), "");
    const { queuesBasePath } = useLiveOpsPathing();
    const newPath = pathAfterQueues
        ? `${queuesBasePath}/${pathAfterQueues}${location.search}${location.hash}`
        : `${queuesBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
